import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class AccountDeliveryHistoryCtrl implements IController {

  account: AccountModel;
  isDemand: boolean;

  private loadLimit: number;
  private deliveriesRef: any;
  private infiniteScroll: any;
  private range: any;
  private customTemplates: any;
  private group: any;
  private status: any;
  private queryString: any;
  private selectedIds: any;
  private selectedAgent: any;
  private enabledStatuses: any;

  /* @ngInject */
  constructor(private $log, private $deliveries, private deliveriesConstants,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $infiniteScroll) {
  }

  $onInit() {
    this.loadLimit = 20;
    this.deliveriesRef = this.$deliveries();

    this.range = this.dateRangeTimeFiltersService.thisMonth();
    this.customTemplates = this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates();
    this.group = this.deliveriesConstants.group.Finished;
    this.status = undefined;
    this.queryString = undefined;
    this.selectedIds = [];
    this.selectedAgent = null;
    this.enabledStatuses = [
      this.deliveriesConstants.status.Canceled,
      this.deliveriesConstants.status.Completed,
      this.deliveriesConstants.status.ManualHandled
    ];

    this.deliveriesRef.$query(this._qetQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.deliveriesRef, this.loadLimit);
  };

  submitQuery(queryString) {
    this.queryString = queryString;
    this._query();
  }

  rangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.range.name)) {
      this.range = range;
      this._query();
    }
  }

  statusChanged(status) {
    this.status = status;
    this._query();
  }

  onSelectAgent(agent) {
    this.selectedAgent = agent;
    this._query();
  }

  selectedIdsChanged(selectedIds) {
    this.selectedIds = selectedIds;
  }

  // ******************************
  //        Private methods
  // ******************************

  private _query() {
    this.selectedIds = [];
    this.deliveriesRef.$query(this._qetQueryPayload()).then(() => {
      this.infiniteScroll.reload();
    }, (resp) => {
      this.$log.debug('Fail to $query', resp);
    });
  }

  private _qetQueryPayload() {
    return {
      agentAccountIds: this.isDemand ? undefined : [this.account.id],
      accountIds: this.isDemand ? [this.account.id] : undefined,
      agentIds: _.get(this.selectedAgent, 'id') ? [this.selectedAgent.id] : undefined,
      from: this.range.dateStart,
      to: this.range.dateEnd,
      group: this.group,
      status: this.status,
      query: this.queryString,
      limit: this.loadLimit
    };
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountDeliveryHistory', {
    bindings: {
      account: '<',
      isDemand: '<'
    },
    template: require('./account-delivery-history.html').default,
    controller: AccountDeliveryHistoryCtrl
  });
